import { useCallback, useEffect, useMemo, useState } from 'react';

import { Stack } from 'react-bootstrap';

import { IDraftOrder } from '@customTypes/draftOrder';
import { fetchDraftOrders } from '@store/actions';

import Drafts from './components/Drafts/Drafts';
import CompletedDrafts from './components/CompletedDrafts/CompletedDrafts';
import DeletedDrafts from './components/DeletedDrafts/DeletedDrafts';

import './DraftOrders.scss';

export default function DraftOrders() {
  const [allDraftOrders, setAllDraftOrders] = useState<IDraftOrder[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const activeDraftOrders = useMemo(
    () => allDraftOrders.filter(draftOrder => draftOrder.status === 'ACTIVE'),
    [allDraftOrders],
  );
  const completedOrders = useMemo(
    () => allDraftOrders.filter(draftOrder => draftOrder.status === 'COMPLETED'),
    [allDraftOrders],
  );
  const deletedDraftOrders = useMemo(
    () => allDraftOrders.filter(draftOrder => draftOrder.status === 'DELETED'),
    [allDraftOrders],
  );

  const loadData = useCallback(async () => {
    try {
      setLoading(true);

      const res = await fetchDraftOrders();
      setAllDraftOrders([...res]);
    } catch (err) {
      console.error('Error on fetching draft orders: ', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <Stack gap={4} className='layout-single-col-py draft-orders-container'>
      <Stack as='section' className='text-start page-title-section'>
        <h1 className='mb-0 fw-bold page-title'>Your Draft Orders</h1>
        <div className='fs-body fw-normal text-second page-subtitle'>
          <p className='mb-1'>
            Draft orders can be seen by the ordering provider, organization default delegates, and clinical team
            delegates for the ordering provider.
          </p>
        </div>
      </Stack>
      <Drafts draftOrders={activeDraftOrders} refetchDraftOrders={loadData} loading={loading} />
      <CompletedDrafts completedOrders={completedOrders} loading={loading} />
      <DeletedDrafts deletedDraftOrders={deletedDraftOrders} loading={loading} />
    </Stack>
  );
}
